import React,{useState,useEffect} from 'react'
import './Best.css'

import SearchBarv2 from '../search/SearchBarv2'
import CardGrid from '../GridViewMain/CardGrid'
import SimilarNavBar from '../search/SimilarNavBar/SimilarNavBar'
import FullCardGrid from '../GridViewMain/FullCardGrid/FullCardGrid'
import translations from '../../utils/language/translations.json'
import { useTranslation } from 'react-i18next';
const Best = () => {
  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.SearchBar[key][currentLang]; // Adjust the path according to your JSON structure
 
  const [resultsVisible,setResultsVisible] = useState(false)
  const [rawSimilarResults,setRawSimilarResults] = useState([])
  const [viewAsGrid,setViewAsGrid] = useState(false)
  const [groupedCards,setGroupedCards] = useState([])
  const areAllElementsSame = (arr) => arr.every((element) => element === arr[0]);
  
  useEffect(() => {
    if (rawSimilarResults.length > 0&&viewAsGrid) {
      const fetchedCards = rawSimilarResults;
      console.log('fetchedCards',fetchedCards)
      const cardMap = fetchedCards.reduce((acc, card) => {
       
        const cardDetails = {
          // Ensure all properties are validated against being null or empty
          id: card.id || "",
          imageFront: card.ImageFront || "",
          imageUserBack: card.ImageUserBack || "",
          graded: card.Graded || "",
          gradeCompany: card.GradeCompany || "",
          grade: card.Grade || "",
          condition: card.Condition || "",
          estimateValue: parseFloat(card.EstimateValue) || "",
          price:parseFloat(card.Price)||"",
          isForSale: card.isForSale || "",
          isForTrade: card.isForTrade || "",
          isOnEbay: card.isOnEbay || "",
          userId: card.UserId || "",
          username: card.Username || "",
          rating: parseFloat(card.Rating) || 4,
          country: card.Country || "",
          shippingCost:6,
          totalSales:24
        };
  
        if (!acc.has(card.CardId)) {
          // Initialize with the current card's details and set the lowestEstimateValue to the current card's EstimateValue
          acc.set(card.CardId, {
            ...card,
            sameCardCount: 1,
            grades: {
              Raw: { 
                count: card.Graded && card.Graded.toLowerCase() === "raw" ? 1 : 0, 
                lowestEstimateValue: card.Graded && card.Graded.toLowerCase() === "raw" ? card.EstimateValue : Infinity 
              },
              Graded: { 
                count: card.Graded && card.Graded.toLowerCase() !== "raw" ? 1 : 0, 
                lowestEstimateValue: card.Graded && card.Graded.toLowerCase() !== "raw" ? card.EstimateValue : Infinity 
              },
            },
            blend: [cardDetails], // Initialize blend as an array with the current card's details
          });
        } else {
          const entry = acc.get(card.CardId);
          entry.sameCardCount += 1;
          entry.blend.push(cardDetails); // Append the current card's details to the blend array
  
          // Update grades logic and lowestEstimateValue
          if (card.Graded && card.Graded.toLowerCase() === "raw") {
            entry.grades.Raw.count += 1;
            entry.grades.Raw.lowestEstimateValue = Math.min(entry.grades.Raw.lowestEstimateValue, card.EstimateValue);
          } else if (card.Graded && card.Graded.toLowerCase() !== "raw") {
            entry.grades.Graded.count += 1;
            entry.grades.Graded.lowestEstimateValue = Math.min(entry.grades.Graded.lowestEstimateValue, card.EstimateValue);
          }
  
          acc.set(card.CardId, entry);
        }
  
        return acc;
      }, new Map());
  
      setGroupedCards(cardMap);
      console.log('cardMap',cardMap)
    }
  }, [rawSimilarResults,viewAsGrid]);


 // Callback function to receive results from the child component
const handleSimilarResults = (results) => {
  console.log('results as been send back',results)
  if(results.length===0)
  {console.log('THIS IS EMPTY')}
  else{
  setRawSimilarResults(results)};
};

// function  handleSimilarResults (results) {
//   setRawSimilarResults(results);
//   };



useEffect(() => {
  // if(rawSimilarResults.length>0)
  console.log('rawSimilarResults should be there', rawSimilarResults);
  if(rawSimilarResults.length>0)
   setResultsVisible(true)
   
  // else console.log('Not yet')
}, [rawSimilarResults]);

return (
  <section className='grid min100 insteadBlock'  >
    <div className="contentfront">
      <div className='justify top-page' style={{gridColumn:'span 12',justifyContent:'center',marginBottom:'2vh'}}>
      <h1>{t('Search the marketplace')}</h1>
      </div>
      
      <SearchBarv2 onSimilarResults={handleSimilarResults} t={t}/>
      {/* Render the userCards instead of dummyCards */}
      {resultsVisible ? (
        <>      
          {/* {areAllElementsSame(rawSimilarResults) ?<SimilarNavBar onSearch={handleSimilarResults} singleCard={rawSimilarResults[0]}/>:(<></>)} */}
          <SimilarNavBar onSearch={handleSimilarResults} singleCard={rawSimilarResults[0]} t={t}/>  
       
        {/* <button className='btn-base' onClick={()=>setViewAsGrid(!viewAsGrid)}>{viewAsGrid?(<>Show as Single</>):(<>Show as Grid</>) }</button> */}
      {/* Render the userCards instead of dummyCards */}
      <FullCardGrid setCards={setRawSimilarResults}cards={rawSimilarResults} groupedCards={groupedCards} 
      viewAsGrid={viewAsGrid} viewOnly={false} cardGridType={'CardGridSell'} ForSearch={true} toggleViewAsGrid={() => setViewAsGrid(!viewAsGrid)}/>

    
        </>
     ) : (
 
     null)}
    </div>
    <div></div>
  </section>
);



}

export default Best